import { render, staticRenderFns } from "./PreviewFrame.vue?vue&type=template&id=fdddaf90&scoped=true"
import script from "./PreviewFrame.vue?vue&type=script&lang=ts"
export * from "./PreviewFrame.vue?vue&type=script&lang=ts"
import style0 from "./PreviewFrame.vue?vue&type=style&index=0&id=fdddaf90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdddaf90",
  null
  
)

export default component.exports